import { Icon, Typography, VStack } from '@vivaahealth/design-system';
import { camelCase } from 'lodash';
import { useTranslation } from 'react-i18next';

import * as api from '../../../api';

import {
  getProviderNameFriendly,
  ProviderNameFields,
} from '../../../utils/provider';
import Row from '../../../components/Row';
import TextData from '../../../components/TextData';
import { constructAddress } from '../../../utils/practice';

const CareProvider = ({
  field,
}: {
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
}) => {
  const { t } = useTranslation('review');
  let careProviders = JSON.parse(field.value);
  const [primary]: api.CareProvider.CareProviderWithAddress[] = Array.isArray(
    careProviders,
  )
    ? careProviders
    : [];

  if (!primary) {
    return null;
  }

  return (
    <VStack gap={16}>
      <Typography variant="headline-small" bold>
        {getProviderNameFriendly(primary as ProviderNameFields, [
          'firstName',
          'lastName',
          'prefix',
        ])}
      </Typography>
      {primary.address && (
        <Row Icon={Icon.MapPin}>
          <TextData
            label={t(camelCase('primaryCareProviderAddress'))}
            value={constructAddress(primary.address)}
          />
        </Row>
      )}
    </VStack>
  );
};

export default CareProvider;
